'use client'
import React, { useState } from 'react'
import { Fragment } from 'react'
import LinkComponent from '@components/LinkComponent'
import Image from 'next/image'
import { Tab } from '@headlessui/react'
import { BiSolidBed, BiSolidBath } from "react-icons/bi"
import { AiOutlineLayout } from "react-icons/ai"
import tailwindConfig from '@tailwind.config'
import CurrencySymbol from '@components/CurrencySymbol'

const ProjectProperties = ({ properties, saleProperties, rentProperties, lang, dictionary }) => {
    const [selectedIndex, setSelectedIndex] = useState(0)

  return (
    <div>
        <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
            <Tab.List className={`sm:w-1/2 w-full`}>
                <Tab as={Fragment} className={`w-1/2`}>
                    {({ selected }) => (
                        /* Use the `selected` state to conditionally style the selected tab. */
                        <button
                        className={
                            selected ? `border-[1px] border-maincolor bg-maincolor text-light p-1 rounded-md` : `border-[1px] border-maincolor text-maincolor p-1 rounded-md`
                        }
                        >
                            {dictionary.forSaleInProject} ({saleProperties})
                        </button>
                    )}
                </Tab>
                <Tab as={Fragment} className={`w-1/2`}>
                    {({ selected }) => (
                        /* Use the `selected` state to conditionally style the selected tab. */
                        <button
                        className={
                            selected ? `border-[1px] border-maincolor bg-maincolor text-light p-1 rounded-md` : `border-[1px] border-maincolor text-maincolor p-1 rounded-md`
                        }
                        >
                            {dictionary.forRentInProject} ({rentProperties})
                        </button>
                    )}
                </Tab>
            </Tab.List>
            <Tab.Panels className='mb-2'>
                <Tab.Panel>
                {properties.map((property, index) => 
                    ((property.saleType == 'sale' || property.saleType == 'salerent') && (
                        <LinkComponent key={property.id} href={`/properties/${property.slug}`}>
                            <div className='w-full flex flex-row items-center justify-between text-maincolor py-2'>
                                <div className='relative w-[120px] aspect-[4/3] rounded-md overflow-hidden'>
                                    <Image
                                        // placeholder="blur"
                                        // blurDataURL={property.blur}
                                        // className='object-fit'
                                        className='object-cover cursor-pointer hover:shadow-xl'
                                        src={property.cover}
                                        // width={imageWidth}
                                        // height={imageHeight}
                                        fill={true}
                                        // alt={property.slug}
                                    />
                                </div>
                                <div className='flex flex-grow flex-col justify-start px-2'>
                                    <p className='sm:hidden flex text-third font-bold'><CurrencySymbol />{property.salePrice}</p>
                                    <div className='flex flex-row justify-between items-center sm:px-2'>
                                        <div className='sm:flex hidden flex-col w-1/3 overflow-x-clip'>
                                            <p className='sm:flex hidden text-third font-bold'><CurrencySymbol />{property.salePrice}</p>
                                            <p className='sm:flex hidden '>{property.name}</p>
                                        </div>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.isStudio ? `${dictionary.studio}` : `${property.bedrooms}` }</p>
                                            <BiSolidBed
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.beds}</p>
                                        </div>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.bathrooms ? `${property.bathrooms}` : `` }</p>
                                            <BiSolidBath
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.baths}</p>
                                        </div>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.livingArea ? `${property.livingArea}` : `` }</p>
                                            <AiOutlineLayout
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.sqm}</p>
                                        </div>

                                    </div>
                                </div>
                                <button className='bg-maincolor text-light w-[80px] sm:w-[150px] h-8 rounded-md'>{dictionary.view}</button>
                            </div>
                        </LinkComponent>
                    ))
                )}
                </Tab.Panel>
                <Tab.Panel>
                {properties.map((property, index) => 
                    ((property.saleType == 'rent' || property.saleType == 'salerent') && (
                        <LinkComponent key={property.id} href={`/properties/${property.slug}`}>
                            <div className='w-full flex flex-row items-center justify-between text-maincolor py-2'>
                                <div className='relative w-[120px] aspect-[4/3] rounded-md overflow-hidden'>
                                    <Image
                                        // placeholder="blur"
                                        // blurDataURL={property.blur}
                                        // className='object-fit'
                                        className='object-cover cursor-pointer hover:shadow-xl'
                                        src={property.cover}
                                        // width={imageWidth}
                                        // height={imageHeight}
                                        fill={true}
                                        // alt={property.slug}
                                    />
                                </div>
                                <div className='flex flex-grow flex-col justify-start px-2'>
                                    <p className='sm:hidden flex text-third font-bold'><CurrencySymbol />{property.rentPrice}{dictionary.perMonth}</p>
                                    <div className='flex flex-row justify-between items-center sm:px-2'>
                                        <div className='sm:flex hidden flex-col w-1/3 overflow-x-clip'>
                                            <p className='sm:flex hidden text-third font-bold'><CurrencySymbol />{property.rentPrice}</p>
                                            <p className='sm:flex hidden '>{property.name}</p>
                                        </div>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.isStudio ? `${dictionary.studio}` : `${property.bedrooms}` }</p>
                                            <BiSolidBed
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.beds}</p>
                                        </div>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.bathrooms ? `${property.bathrooms}` : `` }</p>
                                            <BiSolidBath
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.baths}</p>
                                        </div>
                                        <div className='flex sm:flex-col flex-row sm:items-start items-center'>
                                            <p className='font-semibold'>{property.livingArea ? `${property.livingArea}` : `` }</p>
                                            <AiOutlineLayout
                                                size={16}
                                                color={tailwindConfig.theme.extend.colors.maincolor}
                                                className='sm:hidden block sm:ml-0 ml-2'
                                            />
                                            <p className='sm:block hidden'>{dictionary.sqm}</p>
                                        </div>

                                    </div>
                                </div>
                                <button className='bg-maincolor text-light w-[80px] sm:w-[150px] h-8 rounded-md'>{dictionary.view}</button>
                            </div>
                        </LinkComponent>

                )))}
                </Tab.Panel>
            </Tab.Panels>
        </Tab.Group>
        <div>

        </div>
    </div>
  )
}

export default ProjectProperties